



<head>
  <!-- Add Bootstrap CDN -->
  <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/4.5.2/css/bootstrap.min.css">
  <!-- Add Font Awesome CDN -->
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css">
</head>


<mat-accordion>
   <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)"  [expanded]="panelOpenState()" id="main" class="border" #firstCommonExpansion>
     <mat-expansion-panel-header *ngIf="showcdinfo" style="background: black; height: 50px;">
      <div *ngIf="showcdinfo" class="container-fluid" style="background: black;display: flex;align-items: center;justify-content: space-between;">
         
         <h5 class="mb-0 text-white">NEMA Motor
         </h5><i *ngIf="!panelOpenState()" class="fas fa-plus text-white"></i>
         <i *ngIf="panelOpenState()" class="fas fa-minus text-white"></i>
      </div>
     </mat-expansion-panel-header>
     <mat-expansion-panel-header *ngIf="showspinfo" style="background: #e2001a; height: 50px;">
      <div *ngIf="showspinfo" class="container-fluid" style="background: #e2001a;display: flex;align-items: center;justify-content: space-between;">
         
         <h5 class="mb-0 text-white">NEMA Motor
         </h5><i *ngIf="!panelOpenState()" class="fas fa-plus text-white"></i>
         <i *ngIf="panelOpenState()" class="fas fa-minus text-white"></i>
      </div>
     </mat-expansion-panel-header>
     <div class="card-body">
      <div class="row" [formGroup]="reducerForm">
         <div class="col-lg-6 border left">
            <div class="justify-content-center">
               <table class="table">
                  <tbody>
                     <tr>
                        <div class="row">
                           <div class="col-lg-4 col-md-4 col-sm-4">
                              <label for="inputPower" class="col-form-label">Input Power</label>
                           </div>
                              <div class="col-lg-8 col-md-8 col-sm-8">
                                 <input type="number" step="0.01" id="inputPower" class="form-control" placeholder="Enter Input Power" formControlName="inputPower" #inputPowerField min="0" (input)="checkValue($event)">
                                 <div *ngIf="formSubmitted && (!inputPowerField.value || inputPowerField.value.trim() === '')" class="text-danger">
                                    Please enter a valid number.
                                  </div>
                              </div>
                        </div>

                        <div class="row align-items-center h-100">
                           <div class="col-lg-4 col-md-4 col-sm-4">
                              <label for="metric" class="col-form-label">Units</label>
                           </div>
                           <div class="col-lg-8 col-md-8 col-sm-8">
                              <input class="form-check-input" type="radio" name="selectedUnits" id="metric" formControlName="selectedUnits" style="margin-left: 0px;" value="metric" #inputMetric>
                              <label class="form-check-label" for="metric" style="margin-left: 20px;margin-top: 2px;">
                              Metric (kW)
                              </label>
                              <input class="form-check-input" type="radio" name="selectedUnits" id="imperial" formControlName="selectedUnits" style="margin-left: 20px;margin-right: 5px;" value="imperial" #inputImperial>
                              <label class="form-check-label" for="imperial" style="margin-left: 40px;">
                              Imperial (HP)
                              </label>
                              <div *ngIf="formSubmitted && (!inputMetric.checked && !inputImperial.checked)" class="text-danger">
                                 Please check an option.
                               </div>
                           </div>
                        </div>
                        <div class="row">
                           <div class="col-lg-4 col-md-4 col-sm-4">
                              <label for="inputSpeed" class="col-form-label">Input Speed (rpm)</label>
                           </div>
                           <div class="col-lg-8 col-md-8 col-sm-8">
                               <select class="form-control" id="inputSpeed" formControlName="inputSpeed" name="inputSpeed" #inputSpeedDropdown>
                                 <option [ngValue]="null" disabled selected>--Select--</option>
                                 <option *ngFor="let option of inputSpeed" [value]="option.speed">{{ option.speed }}</option>
                               </select>
                               <div *ngIf="formSubmitted && reducerForm.get('inputSpeed')?.hasError('required')" class="text-danger">
                                 Please select an option.
                               </div>
                               
                           </div>
                        </div>
                        <div class="row">
                           <div class="col-lg-4 col-md-4 col-sm-4">
                              <label for="ratio" class="col-form-label">Ratio</label>
                           </div>
                           <div class="col-lg-8 col-md-8 col-sm-8">
                              <!-- <select class="form-control" id="ratio" name="ratio">
                                 <option value="None">--Select--</option>
                                 <option value="s1">&lt; 50 (Less than 50)</option>
                                 <option value="s2">&gt; 50 (More then 50)</option>
                              </select> -->

                              <!-- <select class="form-control" id="ratio" name="ratio" formControlName="inputRatio" #inputRatioDropdown>
                                 <option value="None" disabled selected>--Select--</option>
                                 <option *ngFor="let option of inputRatio" [value]="option.ratio">{{ option.ratio }}</option>
                               </select>
                               <div *ngIf="formSubmitted && (!inputRatioDropdown.value || inputRatioDropdown.value === 'None')" class="text-danger">
                                 Please select an option.
                               </div> -->



                               <select class="form-control" id="ratio" name="ratio" formControlName="inputRatio" #inputRatioDropdown>
                                 <option [ngValue]="null" disabled selected>--Select--</option>
                                 <option *ngFor="let option of inputRatio" [value]="option.ratio">{{ option.ratio }}</option>
                               </select>
                               <div *ngIf="formSubmitted && reducerForm.get('inputRatio')?.hasError('required')" class="text-danger">
                                 Please select an option.
                               </div>
                               
                               
                           </div>
                        </div>
                        
                        
                        
                     </tr>
                  </tbody>
               </table>
            </div>
         </div>
         <div class="col-lg-6 border right">
            <div class="justify-content-center">
               <table class="table">
                  <tbody>
                     <tr>
                        <div class="row">
                           <div class="col-lg-4 col-md-4 col-sm-4">
                              <label for="dutyCycleYes" class="col-form-label">Duty Cycle</label>
                              <div class="row" style="margin-top: -15px;width: 110px;">
                                 <p (click)="openDialog1()" style="text-decoration: none; color: blue; cursor: pointer;">Need Help?</p>
                                 <ng-template #dialogTemplate let-data="data">
                                    <!-- <h1 mat-dialog-title>Title</h1> -->
                                    
                                    <div mat-dialog-content>
                                      <div class="col-lg-12 col-md-12 col-sm-12" style="display: flex;
 flex-direction: row-reverse;">
                                       <span class="close-btn" (click)="closeDialog()" style="display: flex;
                                    flex-direction: row-reverse;
                                    margin-right: -4px;
                                    margin-top: -10px;
                                    cursor: pointer;height: 20px;">X</span>
                                       <p style="text-align: left;">Thermal input power ratings must be taken into consideration for continuous applications. Intermittent applications often allow the gearbox to cool between cycles, so the thermal limitations can be disregarded. Cone Drive recommends considering thermal input power ratings if the gearbox is operating 30 minutes or more within an hour. Does your application run 30 minutes or more within a 60 minute period?</p>
                                      </div>
                                      <div class="col-lg-12 col-md-12 col-sm-12" style="display: flex;
 flex-direction: row-reverse;">
                                       <button mat-button (click)="dutyCycleOn()" class="btn btn-success" style="margin-left: 15px;">Yes</button>
                                       <button mat-button (click)="dutyCycleOff()" class="btn btn-light" style="background-color: #959696;">No</button>
                                      </div>
                                    </div>
                                    
                                    <!-- <div mat-dialog-actions>
                                      <button mat-button (click)="closeDialog()">Close</button>
                                      <button mat-button (click)="dutyCycleOn()">Yes</button>
                                      <button mat-button (click)="dutyCycleOff()">No</button>
                                    </div> -->
                                  </ng-template>
                              </div>
                           </div>
                           <div class="col-lg-8 col-md-8 col-sm-8">
                              <input class="form-check-input" type="radio" name="dutyCycle" id="dutyCycleYes" formControlName="dutyCycle" style="margin-left: 0px; margin-top: 15px;" value="yes" #dutyCycleYes>
                              <label class="form-check-label" for="dutyCycleYes" style="margin-top: 12px;margin-left: 20px;">
                              &ge;50%
                              </label>
                              <input class="form-check-input" type="radio" name="dutyCycle" id="dutyCycleNo" formControlName="dutyCycle" style="margin-left: 12px;margin-top: 15px;" value="no" #dutyCycleNo>
                              <label class="form-check-label" for="dutyCycleNo" style="margin-left: 30px;">
                              &lt;50%
                              </label>
                              <div *ngIf="formSubmitted && (!dutyCycleYes.checked && !dutyCycleNo.checked)" class="text-danger">
                                 Please check an option.
                               </div>
                           </div>
                        </div>
                        <div class="row" style="margin-top: -25px;">
                           <div class="col-lg-4 col-md-4 col-sm-4">
                              <div class="row">
                                 <label for="serviceFactor" class="col-form-label">Service Factor</label>
                              </div>
                              <div class="row" style="margin-top: -15px;width: 110px;">
                                 <p (click)="openDialog()" style="text-decoration: none; color: blue; cursor: pointer;">Need Help?</p>
                                 
                              </div>
                              <app-image-popup *ngIf="showImagePopup" (close)="closeImagePopup()"></app-image-popup>
                           </div>
                           <div class="col-lg-8 col-md-8 col-sm-8">
                              <input type="number" step="0.1" min="0" max="2.0"  id="serviceFactor" class="form-control" formControlName="serviceFactor"  placeholder="Enter Service Factor" min="0.8" max="2.0" #inputServiceFactor (input)="checkValueSF($event)">
                              <div *ngIf="formSubmitted && (!inputServiceFactor.value || inputServiceFactor.value.trim() === '')" class="text-danger">
                                 Please enter a valid number.
                               </div>
                           </div>
                        </div>
                        <!-- <div class="row">
                           <div class="col-lg-4 col-md-4 col-sm-4">
                              <label for="outputSpeed" class="col-form-label">Output Speed (rpm)</label>
                           </div>
                           <div class="col-lg-8 col-md-8 col-sm-8">
                              <input type="number" id="outputSpeed" class="form-control" disabled>
                           </div>
                        </div> -->
                        <div class="row" style="margin-top: -15px;">
                           <div class="col-lg-4 col-md-4 col-sm-4">
                             <label for="outputSpeed" class="col-form-label">Output Speed (rpm)</label>
                           </div>
                           <div class="col-lg-8 col-md-8 col-sm-8">
                             <input type="number" id="outputSpeed" class="form-control" [value]="outputSpeed !== null ? outputSpeed : ''" disabled>
                           </div>
                         </div>
                         
                        <div class="row">
                           <div class="col-lg-4 col-md-4 col-sm-4">
                           </div>
                           <div class="col-lg-8 col-md-8 col-sm-8">
                              <input class="btn btn-primary w-100" type="submit" value="Submit" (click)="onSubmit()" style="background-color: #59842b; color: white;">
                           </div>
                        </div>
                     </tr>
                  </tbody>
               </table>
            </div>
         </div>
      </div>
   </div>
   
   </mat-expansion-panel>
 </mat-accordion>
 